import moment from 'moment-timezone';

import { types } from './actions';
import { toCentralTime } from '../../utils';

const today = toCentralTime(moment()).toDate();
const currentDate = today.toISOString().split('T')[0];

const defaultState = {
  currentSelectedUserId: null,
  currentSelectedTimesheetDate: currentDate,
  selectedTimeEntryDate: today,
  showTerminatedUsers: false,
  district: null,
  department: null,
};

const timesheetNavigator = (state = defaultState, action) => {
  switch (action.type) {
    case types.SELECT_USER_ID: {
      const { currentSelectedUserId } = action;
      return {
        ...state,
        currentSelectedUserId,
      };
    }
    case types.SELECT_TIMESHEET_DATE: {
      const { currentSelectedTimesheetDate } = action;
      return {
        ...state,
        currentSelectedTimesheetDate,
      };
    }
    case types.SELECT_TIME_ENTRY_DATE: {
      const { selectedTimeEntryDate } = action;
      return {
        ...state,
        selectedTimeEntryDate,
        currentSelectedTimesheetDate: selectedTimeEntryDate.toISOString().split('T')[0],
      };
    }
    case types.SET_SHOW_TERMINATED_USERS: {
      const { showTerminatedUsers } = action;
      return {
        ...state,
        showTerminatedUsers,
      };
    }
    case types.SET_DISTRICT: {
      const { district } = action;
      return {
        ...state,
        district,
      };
    }
    case types.SET_DEPARTMENT: {
      const { department } = action;
      return {
        ...state,
        department,
      };
    }
    default:
      return state;
  }
};

export default timesheetNavigator;
